'use strict'
const cart = require('../script/cart')

module.exports = (cb, options) => {
	if(typeof cb === 'object'){
		options = cb
		cb = null
	}
	options = Object.assign({
		selector: 'form[action="/cart"]'
	}, options)
	const forms = document.querySelectorAll(`${options.selector}:not(data-processed)`)
	for(let i = forms.length; i--;){
		forms[i].addEventListener('submit', addToCart)
		forms[i].dataset.processed = true
	}
	if(cb) cb()
}

function addToCart(e){
	e.preventDefault()
	const $this = this
	this.classList.add('active')
	const data = { xhr: 1 }
	const inputs = this.querySelectorAll('input')
	for(let i = inputs.length; i--;){
		const name = inputs[i].getAttribute('name')
		if(name){
			if(inputs[i].getAttribute('type') != 'checkbox'){
				data[name] = inputs[i].value
			}
			else if(inputs[i].checked){
				data[name] = true
			}
		}
	}


	const req = new XMLHttpRequest()
	req.onreadystatechange = () => {
		if(req.readyState === XMLHttpRequest.DONE){
			// If ajax was successful
			if(req.status === 200){
				const res = JSON.parse(req.responseText)
				cart.update(res)
				$this.classList.add('flipped')
				$this.classList.remove('active')
				setTimeout(() => {
					$this.classList.remove('flipped')
				}, 3000)
			}
			// If not, do it the old fashioned way
			else{
				this.submit()
			}
		}
	}
	req.open('POST', this.getAttribute('action'), true)
	req.setRequestHeader('Content-type', 'application/json')
	req.send(JSON.stringify(data))
	//setTimeout(() => req.send(JSON.stringify(data)), 1000)
}

